type StandardRowHeight = { height: number; class: string; translateKey: string; iconName: string };

const SMALL: StandardRowHeight = {
    height: 34,
    class: 'common-grid-small-row-height',
    translateKey: 'CommonGrid.Height.small',
    iconName: 'row-height-single'
};
const MEDIUM: StandardRowHeight = {
    height: 53,
    class: 'common-grid-medium-row-height',
    translateKey: 'CommonGrid.Height.medium',
    iconName: 'row-height-double'
};
const LARGE: StandardRowHeight = {
    height: 72,
    class: 'common-grid-large-row-height',
    translateKey: 'CommonGrid.Height.large',
    iconName: 'row-height-triple'
};

export const COMMON_GRID_STANDARD_ROW_HEIGHT = SMALL;
export type CommonGridStandardRowHeight = typeof SMALL | typeof MEDIUM | typeof LARGE;
export const commonGridStandardRowHeightOptions: CommonGridStandardRowHeight[] = [SMALL, MEDIUM, LARGE];
